// src/config.js
// export const API_URL = "http://localhost/QR/q5/backend/";
export const API_URL = "https://qr-flex.com/backend/";
export const API_URL2 = "https://qr-flex.com/";
export const PUBLIC_URL = API_URL.replace(/backend\/?$/, "");
export const buildFetchUrl = (id = "") => `${PUBLIC_URL}f/${id}`;
